import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import { FAILED, STARTED } from 'conversations-async-data/async-data/constants/asyncStatuses';
import { PIPELINE_ID, PIPELINE_STAGE_ID } from 'conversations-thread-data/tickets/public/constants';
import { getAccessLevelFromPipeline, getIdFromPipeline, getIdFromStage, getLabelFromPipeline, getLabelFromStage } from 'conversations-thread-data/tickets/public/operators';
import TicketPipelineStageInput from './TicketPipelineStageInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_WIDTH = 500;
const ChangePipelineModal = ({
  onChangePipeline,
  onChangeStage,
  onConfirm,
  onReject,
  pipelineChangeStatus,
  pipelineOptions,
  stageOptions,
  toPipeline,
  toStage
}) => {
  const accessLevel = getAccessLevelFromPipeline(toPipeline);
  const canEdit = accessLevel === undefined ||
  // not all portal have pipeline permissions access so we don't always get this value
  accessLevel.toLowerCase() === 'not_specified';
  const header = /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.header"
      })
    }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onReject
    })]
  });
  const body = /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(TicketPipelineStageInput, {
      canEditProperty: canEdit,
      label: `${PIPELINE_ID}_${getLabelFromPipeline(toPipeline)}`,
      onChange: onChangePipeline,
      options: pipelineOptions,
      value: getIdFromPipeline(toPipeline)
    }), /*#__PURE__*/_jsx(TicketPipelineStageInput, {
      canEditProperty: canEdit,
      label: `${PIPELINE_STAGE_ID}_${getLabelFromStage(toStage)}`,
      onChange: onChangeStage,
      options: stageOptions,
      value: getIdFromStage(toStage)
    })]
  });
  const footer = /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UILoadingButton, {
      "data-selenium-test": "change-pipeline-modal-save-button",
      use: "primary",
      onClick: onConfirm,
      loading: pipelineChangeStatus === STARTED,
      failed: pipelineChangeStatus === FAILED,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.buttons.confirm"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: onReject,
      "data-selenium-test": "change-pipeline-modal-cancel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.changePipelineModal.buttons.cancel"
      })
    })]
  });
  return /*#__PURE__*/_jsxs(UIModal, {
    width: MODAL_WIDTH,
    children: [header, body, footer]
  });
};
ChangePipelineModal.displayName = 'ChangePipelineModal';
export default ChangePipelineModal;